import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Returns a translator scoped to the 'errors' namespace.
 * Falls back to UNKNOWN for any unmapped code, including future backend codes
 * not yet added to errors.json.
 *
 * Usage:
 *   const tError = useErrorTranslation();
 *   tError(extractGqlErrorCode(error))  // → user-facing string
 *   tError('title')                     // → "Error"
 */
export function useErrorTranslation(): (code: string) => string {
  const { t } = useTranslation('errors');
  // Memoized so callers can safely use tError as a useEffect/useCallback dependency
  // without it forcing a re-run on every render.
  return useCallback((code: string): string => t(code, { defaultValue: t('UNKNOWN') }), [t]);
}
